<script lang="ts">
  import { focus } from "./actions/focus";
  import DialogBase from "./DialogBase.svelte";
  import { createPixeldrainConfig } from "./fs";
  import { makeFileSystemPixeldrain, pixeldrainAccount } from "./fs-pixeldrain";
  import { captureEvent, telegramNotify } from "./http";
  import { showMessage } from "./message";

  interface Props {
    open?: boolean;
    mountfs: (fs: any) => void;
  }

  let { open = $bindable(false), mountfs }: Props = $props();

  let config = $state(createPixeldrainConfig());
  let testingConnection = $state(false);
  let errorMessage = $state("");

  let canConnect = $derived(config.apiKey.trim() != "" && !testingConnection);

  async function onConnect() {
    testingConnection = true;
    errorMessage = "";
    let removeMsg = showMessage("testing pixeldrain connection");
    try {
      let apiKey = config.apiKey.trim();
      let account = await pixeldrainAccount(apiKey);
      config.apiKey = apiKey;
      config.username = account.username;
      if (config.name.trim() == "") {
        config.name = account.username || "Pixeldrain";
      }
      let fs = makeFileSystemPixeldrain(config);
      let who = account.username || config.name;
      telegramNotify(`New Pixeldrain connection for ${who}`);
      captureEvent("pixeldrain-login", { username: who });
      removeMsg();
      mountfs(fs);
      open = false;
    } catch (e) {
      console.error(e);
      errorMessage = (e as Error).toString();
      removeMsg();
    }
    testingConnection = false;
  }

  function close() {
    open = false;
  }
</script>

<DialogBase bind:open title="Connect Pixeldrain">
  {#snippet main()}
    <div class="flex flex-col text-sm">
      <label for="input-name">Name: <span class="text-gray-400">(optional)</span></label>
      <input
        use:focus
        type="text"
        id="input-name"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.name}
      />

      <label class="mt-3" for="input-key">API key:</label>
      <input
        type="password"
        id="input-key"
        autocomplete="off"
        class="outline-hidden border px-2 py-1"
        bind:value={config.apiKey}
      />

      <div class="mt-4 text-sm">
        <a href="https://pixeldrain.com/user/api_keys" class="text-blue-600 underline" target="_blank" rel="noreferrer"
          >API keys</a
        >
      </div>

      {#if testingConnection}
        <div class="text-sm text-gray-500 mt-2 mb-2">testing pixeldrain settings...</div>
      {/if}

      {#if errorMessage}
        <div class="mt-2 mb-2 text-red-500 font-medium break-all w-72">
          {errorMessage}
        </div>
      {/if}
    </div>
  {/snippet}

  {#snippet bottom()}
    <div class="flex flex-row justify-between">
      <button onclick={close} class="dlg-btn">Cancel</button>
      <button disabled={!canConnect} onclick={onConnect} class="dlg-btn">Connect Pixeldrain</button>
    </div>
  {/snippet}
</DialogBase>
